export default __webpack_public_path__ + "static/media/touchpad3_active_v1.e0dc5a01.svg";